import React, { useState } from "react";
import Table from 'react-bootstrap/Table';

export default function TableComponent(props) {
  
    return (
        <Table className={`${props.isCentered && 'table-centered'} table-borderless table-nowrap-mobile ${props.tableAlignment} ${props.isStriped && 'table-striped '} ${props.shouldOverflow && 'overflow-x-auto'}`} data-sorting={true}>
            <thead>
                {props.tableHeaders}
            </thead>
            <tbody>
                {props.tableRows}
            </tbody>
        </Table>
    );
}